<template>
  <div>Página não autorizada...</div>
</template>

<script>
export default {
  created() {
    this.$store.commit("pageHasLoaded");
  },
};
</script>

<style>
</style>